import { reactive } from "vue";
export const tradeFabListContext = reactive({
    fullPath: "",
    albumId: "",
    albumName: "",
    suggestedPrice: "",
    issueNum: "",
    soldNum: ""
});
export function syncTradeFabFromOnSaleList(payload) {
    tradeFabListContext.fullPath = payload.fullPath || "";
    tradeFabListContext.albumId = payload.albumId || "";
    tradeFabListContext.albumName = payload.albumName || "";
    tradeFabListContext.suggestedPrice = payload.suggestedPrice || "";
    tradeFabListContext.issueNum = payload.issueNum || "";
    tradeFabListContext.soldNum = payload.soldNum || "";
}
export function clearTradeFabListContext() {
    tradeFabListContext.fullPath = "";
    tradeFabListContext.albumId = "";
    tradeFabListContext.albumName = "";
    tradeFabListContext.suggestedPrice = "";
    tradeFabListContext.issueNum = "";
    tradeFabListContext.soldNum = "";
}
